<template>
  <section class="w-full mb-10">
    <Loader v-if="loading" :loader="loading" loaderSize="h-[80vh]" />

    <div v-else-if="error" class="h-[60vh]">
      <EmptyData
        :data="error"
        :title="`${$t('studentCourse.errors.pdf.title')}`"
        :label="`${$t('studentCourse.errors.pdf.description')}`"
        :image="'waiting_object.svg'"
        imgSize="h-40"
        msgSize="text-xl lg:w-5/12"
      />
    </div>
    <iframe
      v-else
      :src="validatedUrl"
      class="w-full h-[80vh]"
      @load="handleIframeLoad"
    />
  </section>
</template>

<script lang="ts">
import axios from "axios";
import { defineComponent } from "vue";
export default defineComponent({
  name: "pdf-component",
  data() {
    return {
      time: 0 as number,
      TIMER: "" as any,
      error: false as boolean,
      validatedUrl: "" as string,
      loading: true as boolean,
    };
  },
  props: {
    url: {
      required: true,
      type: String,
    },
  },
  mounted() {
    this.timer();
    this.validateUrl(this.url);
  },
  unmounted() {
    clearInterval(this.TIMER);
  },
  methods: {
    timer(): void {
      this.TIMER = setInterval(() => this.time++, 1000);
    },
    async validateUrl(url: string): Promise<void> {
      try {
        const response = await axios.get(url);
        if (response.data) this.validatedUrl = url;
        else throw new Error(`HTTP status: ${response.status}`);
      } catch (error) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    handleIframeLoad(): void {
      this.loading = false;
    },
  },
});
</script>
